export const AXA_LEAD_BRANDING_TYPE = "axa-lead";
export const AXA_CO_BRANDED_BRANDING_TYPE = "axa-co-brand";
export const PARTNER_CO_BRANDED_BRANDING_TYPE = "partner-co-brand";
